<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Vector">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M0 13.5C0 14.8807 1.11929 16 2.5 16H8.78126C10.162 16 11.2813 14.8807 11.2813 13.5V12.25C11.2813 11.9048 11.0014 11.625 10.6563 11.625C10.3111 11.625 10.0313 11.9048 10.0313 12.25V13.5C10.0313 14.1904 9.47161 14.75 8.78126 14.75L2.5 14.75C1.80965 14.75 1.25 14.1904 1.25 13.5L1.25 2.5C1.25 1.80965 1.80965 1.25 2.5 1.25L8.78126 1.25C9.47161 1.25 10.0313 1.80965 10.0313 2.5V3.75C10.0313 4.09518 10.3111 4.375 10.6563 4.375C11.0014 4.375 11.2813 4.09518 11.2813 3.75V2.5C11.2813 1.11929 10.162 0 8.78126 0L2.5 0C1.11929 0 0 1.11929 0 2.5L0 13.5Z"
        fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M6.12501 8.03125C6.12501 8.37643 6.40483 8.65625 6.75001 8.65625H15.2188C15.5639 8.65625 15.8438 8.37643 15.8438 8.03125C15.8438 7.68607 15.5639 7.40625 15.2188 7.40625L6.75001 7.40625C6.40483 7.40625 6.12501 7.68607 6.12501 8.03125Z"
        fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M13.2589 10.5357C13.503 10.7798 13.8987 10.7798 14.1428 10.5357L15.5424 9.1361C16.1525 8.5259 16.1526 7.53661 15.5424 6.92641L14.1428 5.52681C13.8987 5.28273 13.503 5.28273 13.2589 5.5268C13.0148 5.77088 13.0148 6.16661 13.2589 6.41069L14.6585 7.81028C14.7805 7.93233 14.7805 8.13017 14.6585 8.25222L13.2589 9.65181C13.0148 9.89589 13.0148 10.2916 13.2589 10.5357Z"
        fill="white" />
    </g>
  </svg>
</template>
  
<script>
export default {
  name: "SignOut",
};
</script>